import { postAxios, getAxios } from '@/lib/axios';

export const employeeApi = {
  // 分页查询员工列表 @lilyunfei
  queryEmployeeList(data) {
    return postAxios('/admin/employee/query', data);
  },

  // 新增员工 @lilyunfei
  addEmployee(data) {
    return postAxios('/admin/employee/add', data);
  },

  // 员工管理-修改员工 @lilyunfei
  updateEmployee(data) {
    return postAxios('/admin/employee/update', data);
  },

  // 删除员工 @lilyunfei
  deleteEmployee(employeeId) {
    return getAxios(`/admin/employee/delete/${employeeId}`);
  },

  // 修改员工密码 @lilyunfei
  updatePwd(data) {
    return postAxios('/admin//employee/updatePwd', data);
  },

  // 重置员工密码 @lilyunfei
  resetPwd(employeeId) {
    return getAxios(`/admin/employee/resetPwd/${employeeId}`);
  },

  // 员工管理-给员工分配角色 @lilyunfei
  saveEmployeeRole(data) {
    return postAxios('/admin/employee/saveEmployeeRole', data);
  },

  // 员工管理-批量为多个员工设置角色 @lilyunfei
  batchAddRoleEmployee(data) {
    return postAxios('/admin/employee/batchAddRoleEmployee', data);
  },

  // 员工管理-删除员工角色 @lilyunfei
  deleteEmployeeRoles(data) {
    return postAxios('/admin/employee/deleteEmployeeRoles', data);
  }
};
